// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"94d19422","373":"376816fa","469":"1daacabb","671":"de8f3b93","835":"d83d5313"}[chunkId] + ".chunk.css";
};